import { useState, useEffect } from "react";
import { getNavbar } from "../api/navbar/requests";

function useStoryblokNavigation(story_language) {
  const [nav, setNav] = useState({});

  useEffect(() => {
    if (!nav[story_language]) {
      getNavbar()
        .then((story) => {
          if (story) {
            setNav({ ...nav, [story_language]: story });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, []);

  return nav[story_language];
}

export { useStoryblokNavigation };
